<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="icon-toggle">
        <div
          class="dot cursor-pointer green"
          @click="extraExpanded = !extraExpanded"
        >
          <em class="title-icon" :class="getIcon(extraExpanded)" />
        </div>
        <span class="dot-title">Información de Plan de Intervención</span>
      </div>
    </div>
    <div v-if="extraExpanded && value.length > 0" class="col-md-12 mt-2">
      <div class="box-container">
        <div
          v-for="(plan, index) in value"
          :key="'intervention-plan' + index"
          class="row p-3 box-container__row"
        >
          <div class="col-md-2">
            <custom-balloon
              :background-color="'green'"
              class="mt-2"
              :text="plan.status"
            />
          </div>
          <div class="col-md-3">
            <div class="legend">Fecha:</div>
            <div class="font-weight-normal text-black">
              {{ plan.lastUpdated | date }}
            </div>
          </div>
          <div class="col-md-4">
            <div class="legend">Tipo:</div>
            <div class="font-weight-normal text-black">
              {{ plan.documentType }}
            </div>
          </div>
          <div class="col-md-3 text-right">
            <action-button
              class="mr-n3"
              i="fas fa-download"
              text="Ver Documento"
              variant="outline-success transparent-color bg-transparent"
              @click="$emit('on-view-document', plan)"
            />
          </div>
          <div
            v-if="index != value.length - 1"
            class="col-md-12 separator-line-2 mt-4"
          />
        </div>
        <div
          v-if="!hasPlan"
          class="ml-2 no-eligible-message pl-2 color-secondary-20 text-center"
        >
          Plan de Intervención no ha sido Sometido.
        </div>
      </div>
    </div>
    <div
      v-if="extraExpanded && studentInfo.isPlanSubmitted"
      class="col-md-12 mt-2"
    >
      <div class="box-container">
        <div class="row p-3 box-container__row">
          <div class="col-md-2">
            <custom-balloon
              :background-color="'green'"
              class="mt-2"
              text="Sometido"
            />
          </div>
          <div class="col-md-3">
            <div class="legend">Fecha:</div>
            <div class="font-weight-normal text-black">
              {{ studentInfo.planSubmittedDate | date }}
            </div>
          </div>

          <div class="col-md-7 text-right">
            <action-button
              class="mr-n3"
              i="fas fa-search"
              text="Ver Plan"
              variant="outline-success transparent-color bg-transparent"
              @click="$emit('on-view-plan')"
            />
          </div>
        </div>
        <div
          v-if="!hasPlan"
          class="ml-2 no-eligible-message pl-2 color-secondary-20 text-center"
        >
          Plan de Intervención no ha sido Sometido.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';

export default {
  name: 'StudentInterventionPlanInfo',
  components: {
    CustomBalloon,
    ActionButton,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    studentInfo: {
      type: Object,
      default: () => {},
    },
    hasPlan: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      extraExpanded: false,
    };
  },
  computed: {
    getIcon() {
      return (expanded) =>
        expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.icon-toggle {
  display: flex;
  align-items: center;
  border-radius: 32px;
  padding: 5px;
  display: inline-block;
  background: map-get($colors, 'gray-9');
  padding-left: 5px;
  padding-right: 20px;

  .dot-title {
    font: Bold 18px/22px Lato;
    letter-spacing: 0px;
    color: map-get($colors, 'black');
  }

  .title-icon {
    color: map-get($colors, 'white');
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 7px;
  }
}

.dot-title {
  font: Bold 18px/22px Lato;
  letter-spacing: 0px;
  color: map-get($colors, 'black');
}

.dot {
  box-shadow: 0px 3px 6px map-get($colors, 'black-transparency-41');
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
  margin-right: 15px;
}

.dot.green {
  background-color: map-get($colors, 'green');
}
.dot.gray {
  background-color: map-get($colors, 'gray-7');
}
.box-container {
  background: map-get($colors, 'secondary-3');
  padding: 10px;
  border-radius: 5px;

  &__row {
    margin: 8px 5px;
  }
}

.transparent-color:hover {
  color: map-get($colors, 'green') !important;
}

.separator-line-2 {
  border-bottom: 1px solid map-get($colors, 'gray-5');
}
</style>
